﻿function sanitizeHTML(str) {
    var temp = document.createElement('div');
    temp.textContent = str;
    return temp.innerHTML;
};

export function convertCommentWithLinkTagToHtmlContent(comment) {
    var sanitizedComment = sanitizeHTML(comment);
    var linkTagRegex = /\[\[(.*)\]\]/gm;
    var newLineRegex = /(\r\n|\r|\n)/gm;
    return sanitizedComment.replace(linkTagRegex, '<a target="_blank" href="$1">$1</a>').replace(newLineRegex, "<br/>");
}